"use strict";
globalThis.Validation = (() => {
  const { $, show, hide } = Utils;
  const rules = {
    required: (msg = "Dit veld is verplicht") => (val) => ({
      valid: val != null && String(val).trim() !== "",
      message: msg
    }),
    email: (msg = "Voer een geldig e-mailadres in") => (val) => ({
      valid: !val || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val),
      message: msg
    }),
    phone: (msg = "Voer een geldig telefoonnummer in") => (val) => ({
      valid: !val || /^[\d\s\-+()]{10,}$/.test(val.replaceAll(" ", "")),
      message: msg
    }),
    postcode: (msg = "Voer een geldige postcode in (1234 AB)") => (val) => ({
      valid: !val || /^\d{4}\s?[A-Za-z]{2}$/.test(val),
      message: msg
    }),
    minLength: (min) => (val, msg = `Minimaal ${min} tekens`) => ({
      valid: !val || String(val).length >= min,
      message: msg
    }),
    maxLength: (max) => (val, msg = `Maximaal ${max} tekens`) => ({
      valid: !val || String(val).length <= max,
      message: msg
    }),
    range: (min, max) => (val, msg = `Waarde moet tussen ${min} en ${max} liggen`) => {
      const n = Number(val);
      return {
        valid: !val || !Number.isNaN(n) && n >= min && n <= max,
        message: msg
      };
    },
    checked: (name, msg = "Maak een keuze") => ({
      valid: !!$(`input[name="${name}"]:checked`),
      message: msg
    }),
    minItems: (min) => (arr, msg = `Voeg minimaal ${min} item(s) toe`) => ({
      valid: Array.isArray(arr) && arr.length >= min,
      message: msg
    })
  };
  const validate = (value, validators) => {
    const errors = [];
    for (const validator of validators) {
      const result = typeof validator === "function" ? validator(value) : validator;
      if (!result.valid) errors.push(result.message);
    }
    return { valid: errors.length === 0, errors };
  };
  const validateForm = (schema, values) => {
    const errors = {};
    let valid = true;
    Object.entries(schema).forEach(([field, validators]) => {
      const result = validate(values[field], validators);
      if (!result.valid) {
        valid = false;
        errors[field] = result.errors;
      }
    });
    return { valid, errors };
  };
  const showError = (input, message) => {
    if (!input) return;
    const container = input.closest(".form-field") || input.parentElement;
    let errorEl = container.querySelector(".validation-error");
    if (!errorEl) {
      errorEl = document.createElement("p");
      errorEl.className = "validation-error text-red-600 text-xs mt-1";
      container.appendChild(errorEl);
    }
    errorEl.textContent = message;
    show(errorEl);
    input.classList.add("border-red-500");
    input.setAttribute("aria-invalid", "true");
  };
  const clearError = (input) => {
    if (!input) return;
    const container = input.closest(".form-field") || input.parentElement;
    const errorEl = container.querySelector(".validation-error");
    if (errorEl) hide(errorEl);
    input.classList.remove("border-red-500");
    input.removeAttribute("aria-invalid");
  };
  const showInlineMessage = (container, message, type = "error") => {
    if (!container) return;
    let msgEl = container.querySelector(".inline-validation-msg");
    if (!msgEl) {
      msgEl = document.createElement("div");
      msgEl.className = "inline-validation-msg px-3 py-2 rounded-lg text-sm font-medium mt-2";
      container.insertBefore(msgEl, container.firstChild);
    }
    msgEl.className = `inline-validation-msg px-3 py-2 rounded-lg text-sm font-medium mt-2 ${type === "error" ? "bg-red-50 text-red-700" : "bg-green-50 text-green-700"}`;
    msgEl.textContent = message;
    show(msgEl);
    if (type === "success") {
      setTimeout(() => hide(msgEl), 3e3);
    }
  };
  const clearInlineMessage = (container) => {
    const msgEl = container?.querySelector(".inline-validation-msg");
    if (msgEl) hide(msgEl);
  };
  const highlightSelection = (container, cls = "wizard-option") => {
    const option = container?.querySelector(`.${cls} div`);
    if (option) {
      option.classList.add("ring-2", "ring-red-400", "ring-offset-2");
      setTimeout(() => option.classList.remove("ring-2", "ring-red-400", "ring-offset-2"), 2e3);
    }
  };
  return Object.freeze({
    rules,
    validate,
    validateForm,
    showError,
    clearError,
    showInlineMessage,
    clearInlineMessage,
    highlightSelection
  });
})();
